import React, { memo, useContext } from 'react';
import classNames from 'classnames';
import { Size } from '../_util/enum';
import ConfigContext from '../config-provider/ConfigContext';
const Group = function Group(props) {
    const { prefixCls: customizePrefixCls, className = '', size, compact, style, children } = props;
    const { getPrefixCls } = useContext(ConfigContext);
    const prefixCls = getPrefixCls('input-group', customizePrefixCls);
    const cls = classNames(prefixCls, {
        [`${prefixCls}-lg`]: size === Size.large,
        [`${prefixCls}-sm`]: size === Size.small,
        [`${prefixCls}-compact`]: compact,
    }, className);
    return (React.createElement("span", { className: cls, style: style }, children));
};
Group.displayName = 'Group';
export default memo(Group);
